import { Note } from "../../models/Note";
import { CrewTypes } from "../../constants/enums";
import { Crew } from "../../models/Crew";
import { generateContacts } from "./dummy-data";

const crewCounts = {};
const crewLaborers = [];

function generateCrewNotes() {
  let notes = [];

  // Generate "random" number between 0 and 5
  const numberOfNotes = Math.floor(Math.random() * 5);

  for (let i = 0; i <= numberOfNotes; i++) {
    notes.push(new Note({ title: "Note title", content: `Content ${i + 1}` }));
  }

  return notes;
}

export function generateCrews() {
  let crews = [];
  let crewsCount = 1;

  for (const type in CrewTypes) {
    // Generate "random" number between 0 and 10
    const numberOfCrews = Math.floor(Math.random() * 10);

    crewCounts[CrewTypes[type]] = numberOfCrews;

    for (let i = 1; i <= numberOfCrews; i++) {
      const laborers = generateContacts();
      const notes = generateCrewNotes();
      crews.push(
        new Crew({
          id: crewsCount,
          type: CrewTypes[type],
          supervisor: "Firstname Lastname",
          leader: "Firstname Lastname",
          laborers,
          laborers_count: laborers.length,
          notes,
          notes_count: notes.length
        })
      );

      crewsCount++;
      crewLaborers.push(...laborers);
    }
  }

  return crews;
}

export const crewsIndexData = {
  crewCounts,
  crewLaborers
};
